export default {
  payWelfareText: 'Benefit Top Up',
  blackFridayDiscount: 'Diskon Terbatas Black Friday',
  shareGift: 'Hadiah Share',
  vipWeeklyWelfare: 'Diskon Mingguan VIP',
  exchangeCoupon: 'Kupon Exchange',
  firstPayOff: 'Pembelian pertama kali bisa menikmati max 15%OFF',
  blackFridayEvent: 'Event Black Friday',
  limitedTimeOff: 'Diskon Terbatas 10% OFF',
  claimCoupon: 'Klaim Sekarang',
  blackFridayTimedCoupon:
    'Diskon Terbatas Black Friday -> Diskon Terbatas Black Friday',
  timeLeft: 'Sisa Event:',
  claimTimeCoupon: 'Klaim Terbatas Kupon 10% OFF',
  points: 'Sisa Poin: ${point}',
  costPointTip: 'Konsumsi poin untuk klaim Kupon tahap apa pun',
  maxPointTip: 'Setiap akun hanya bisa pakai max 500 poin',
  discountOff: '10% OFF',
  highestDiscount: 'Max Diskon: ${discount} ',
  needPoint: 'Perlu poin ${point}',
  changeCurrency: 'Ganti Mata Uang',
  claim: 'Klaim',
  claimSucc: 'Berhasil klaim',
  claimFail: 'Gagal klaim',
  pointNotEnough: 'Kekurangan poin',
  afterClaimPoint: 'Poin setelah klaim: ${point}',
  footTips1: '1 Kupon hanya untuk 1 pesanan',
  footTips2: 'Tidak mendukung Kupon ini saat beli Voucer',
  footTips3: 'Hak interpretasi akhir adalah milik tim operasional game.',
  ruleTitleText: 'Aturan Event',
  ruleTime: 'Waktu Event: 24/11/2023 00:00 ~ 26/11/2023 23:59 (UTC)',
  bfRuleText1:
    '1. Selama Event, akun yang login ke halaman Top Up offcial untuk pertama kalinya akan mendapat 400 poin, bisa digunakan untuk menukar Kupon, max bisa gunakan 500 poin.',
  bfRuleText2:
    '2. Selama Event, gunakan poin Black Friday bisa tukar Kupon dengan kuota berapa pun. Semakin tinggi kuota diskon, semakin banyak poin yang diperlukan. Setelah berhasil, akan mengurangi poin relevan.',
  bfRuleText3:
    '3. Setiap nomor pesanan hanya bisa menggunakan 1 Kupon. Item Voucer tidak mendukung Kupon Black Friday.',
  bfRuleText4: '4. Kopun Blac Friday hanya mendukung mata uang berikut:',
  ableCoinsType: 'USD,JPY,KRW,TWD,EUR,HKD,GBP,CAD,AUD,RUB,MYR,THB,PLN,IDR',
  bfRuleText5:
    '5. Setelah berhasil, tidak bisa ganti mata uang, juga tidak mendukung pengembalian poin. Silakan perhatikan kuota diskon dan konsumsi poin.',
  bfRuleText6:
    '6. Masa berlaku Kupon Black Friday hanya 7 hari. Harap digunakan dengan cermat.',
  bfRuleText7: '7. Hak interpretasi akhir adalah milik tim operasional game.',
  thanksTip:
    'Terima kasih atas partisipasi Anda, silakan follow komunistas official untuk event lainnya',
  exchangePoints: 'Kupon Exchange -> Tukar Poin',
  exchangeCode:
    'Silakan masukkan Redeem code setelah pilih metode pembayaran -> Masukkan Redeem code',
  enterExchangeCode:
    'Masukkan Redeem code di sini -> Silakan masukkan Redeem code',
  exchangeText: 'Tukar',
  confirmGet: 'Konfirmasi',
  couponUsedWay:
    'Kupon hanya bisa digunakan di metode pembayaran dengan mata uang yang ditentukan. Harap konfirmasi mata uang pembayaran yang ingin Anda gunakan.',
  confirmText: 'Konfirmasi',
  exchangeSucc: 'Berhasil',
  aboutCoins: 'Mengenai Voucer',
  aboutCoinsText:
    'Voucher bisa tukar semua paket hadiah dan layanan nilai tambah dalam game ini kecuali voucher',
  known: 'Mengerti',
  codeText: 'Redeem code',
  codeInvalid: 'Gagal redeem!',
  hasExchanged: 'Anda sudah tukar, hanya bisa klaim Redeem code sebanyak 1x!',
  hideText: 'Sembunyikan',
  //黑五的报错码
  'bf-20001': 'Belum Login',
  'bf-20002': 'Parameter salah. Silakan coba lagi masuk Event',
  'bf-20003': 'Kekurangan poin',
  'bf-20004': 'Gagal klaim. Silakan coba lagi nanti atau hubungi CS',
  'bf-20005': 'Sudah klaim',
  'bf-20015': 'Event tidak tersedia. Silakan nantikan',
  'bf-20016': 'Event Berakhir',
  bfShareText: 'Klaim Terbatas Kupon 10% OFF',
  rightsCenterBtn: 'Pusat Anggota',
  payBtn: 'Bayar',
  hasEqualRewardMuglo: 'Up to 1800 Diamonds BONUS from official website top-up!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Kemuliaan Agung (Permanen)',
  rightCenterNoticeTitle: 'Tentang peningkatan mekanisme poin VIP menjadi [Pusat Benefit]',
  rightCenterNoticeContent: 'Komandan terhormat:<br />Terima kasih atas dukungan Anda selama ini! Untuk memberikan pengalaman manfaat yang lebih baik, kami akan melakukan Upgrade menyeluruh terhadap mekanisme Poin VIP yang ada pada 16/7/2025, dan meluncurkan sistem "Pusat Benefit" yang baru. Upgrade ini akan mengintegrasikan hak istimewa VIP yang ada dan menambahkan lebih banyak manfaat. Penyesuaian spesifik adalah sebagai berikut:<br />1. Penjelasan Konten Update Versi<br />Manfaat login mingguan dipertahankan<br />Selama periode 16 Juli - 29 Juli 2025, semua pemain yang login ke [official website top up page] masih bisa mendapatkan "Kupon Diskon VIP Mingguan". Jumlah kupon yang diterima sama dengan [Event Poin VIP]. Selain itu, semua pemain bisa menukarkan kupon versi baru di [Pusat Benefit]. Kupon dari Pusat Benefit akan memiliki limit maksimum potongan harga. Aturan kupon baru dan jumlah yang bisa didapat bisa dilihat di tabel di bawah halaman.<br />Perhatian: Fitur pemberian kupon otomatis perlu diaktifkan secara manual. Cara mengaktifkan: Halaman utama Pusat Benefit - Lihat benefit anggota - Pemberian kupon otomatis - Klik aktifkan - Pilih kupon yang ingin ditukar otomatis - Konfirmasi pengaktifan<br />Tambahan keuntungan penukaran poin<br />Pusat Benefit akan membuka fitur "Penukaran Poin". Pemain bisa mendapatkan poin dengan login game, menyelesaikan misi khusus di Pusat Benefit, dll. Poin bisa ditukar dengan kupon eksklusif, item langka, dan hadiah menarik lainnya (jumlah yang bisa ditukar bisa dilihat di antarmuka Pusat Benefit).<br />Jaminan pewarisan Level VIP<br />Level VIP dan total poin Anda akan sepenuhnya dipindahkan ke pusat benefit, dan otomatis dikonversi ke level yang sesuai. Semua hak istimewa VIP Anda akan dipertahankan dan ditingkatkan.<br />2. Keunggulan Setelah Update Versi<br />Benefit lebih transparan: Semua aturan dan hadiah ditampilkan dengan jelas, mudah diklaim dengan sekali tekan.<br />Hadiah lebih besar: Tambahan event tukar poin, item bernilai tinggi diperbarui secara berkala.<br />Bonus undian: Selain penukaran poin, ada juga event undian untuk memenangkan item game.<br />3. Hal-hal yang Perlu Diperhatikan<br />Selama masa transisi (16/7/2025-29/7/2025), akses Poin VIP lama akan ditutup bertahap (namun kupon masih diberikan sebelum penutupan). Harap segera gunakan sisa kupon Anda. Kupon yang belum digunakan akan hangus setelah [Event Poin VIP] ditutup.<br />Setelah Pusat Benefit diluncurkan, Anda dapat mengaksesnya melalui [Pusat Top-up Official] - [Avatar] - [Pusat Benefit]',
  rightCenterNoticeTableTitle: 'Perbandingan Perubahan Kupon',
  rightCenterNoticeTableHeader1: 'Syarat Penukaran - Level Anggota VIP',
  rightCenterNoticeTableHeader2: 'Level VIP Asli',
  rightCenterNoticeTableHeader3: 'Diskon Kupon',
  rightCenterNoticeTableHeader4: 'Limit perolehan',
  rightCenterNoticeTableHeader5: 'Limit diskon',
  rightCenterNoticeTableLevel1: 'Bronze',
  rightCenterNoticeTableLevel2: 'Silver',
  rightCenterNoticeTableLevel3: 'Gold',
  rightCenterNoticeTableLevel4: 'Platinum',
  rightCenterNoticeTableLevel5: 'Diamond',
  rightCenterNoticeTableCount1: '1x/hari',
  rightCenterNoticeTableCount2: '15x/bulan',
  rightCenterNoticeTableCount3: '10x/bulan',
  rightCenterNoticeTableLimit: '15USD',
  rightCenterNoticeTableTip: 'Perhatian: Limit maksimal diskon kupon di [Pusat Benefit] berdasarkan USD. Karena fluktuasi nilai tukar, jumlah yang ditampilkan di halaman penggunaan aktual adalah yang berlaku.',
  '-': '-'
};
